import Content from "./Content/index.js";
import Utils from "../../../../Utils.js";
class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/greeting`;
    }
    /**
     * Creates a custom company greeting.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/greeting
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: ReadUserInfo
     */
    async post(createCompanyGreetingRequest, restRequestConfig) {
        const formData = await Utils.getFormData(createCompanyGreetingRequest);
        const r = await this.rc.post(this.path(), formData, undefined, restRequestConfig);
        return r.data;
    }
    content() {
        return new Content(this);
    }
}
export default Index;
